import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { SpinnerCard } from '../common/Layout'
import { Link } from 'react-router-dom'
import { friendsRoute } from '../../routes/routes'
import { format } from 'date-fns'
import { InputError } from '@foodsby/nutrient'
import FriendLabel from './FriendLabel'
import {
  getFriendRequestCount,
  getFriendsOrdersStart,
  loadFriendsStart
} from '../../redux/modules/friends'
import LinkPopup from '../common/LinkPopup'
import LoginOrJoin from '../login/LoginOrJoin'

const LOW_FRIENDS_CUTOFF = 3
const DEFAULT_VIEWABLE_FRIENDS = 6

export const NotAuthed = ({ locationId }) => (
  <div className="card notAuthed">
    <div className="row center-xs">
      <div className="friendsTitle">
        <i className="icon-users" />
        Friends
      </div>
    </div>
    <hr />
    <div className="row center-xs">
      <div className="col-xs-12 center-xs">
        <LinkPopup linkText="Login to manage friends." maxWidth="1024px">
          <LoginOrJoin
            loginTitle="Login to Manage Friends"
            joinTitle="Register to Add Friends"
            loginMessage="Login to manage friends, and get lunch to your office."
            signupMessage="Sign up to add friends, and get lunch to your office."
            locationId={locationId}
          />
        </LinkPopup>
      </div>
    </div>
  </div>
)

export const ManageFriends = () => (
  <div className="row middle-xs center-xs manageFriends">
    <Link to={friendsRoute.path} data-gtm-elm-id="manageFriends">
      Manage Friends
    </Link>
  </div>
)

export const AddFriends = () => (
  <div className="row middle-xs center-xs manageRequests">
    <Link
      to={friendsRoute.path}
      className="button secondary"
      data-gtm-elm-id="addFriendsBtn"
    >
      Add Friends
    </Link>
  </div>
)

export const FriendsNotOrderedYet = ({
  friendCount,
  friendNotOrdered,
  showMore,
  requestCount,
  handleClick
}) => (
  <div className="center-xs">
    {friendNotOrdered && (
      <Fragment>
        <h4 className="friendSubtitle">Haven't Ordered</h4>
        {friendNotOrdered
          .slice(0, showMore ? friendCount : DEFAULT_VIEWABLE_FRIENDS)
          .map((friend, i) => (
            <div className="friendSidebarLabel" key={i}>
              <FriendLabel
                classNames={{ friendIconWrapper: true }}
                firstName={friend.firstName}
                lastName={friend.lastName}
                email={friend.email}
                showEmail={false}
              />
            </div>
          ))}
      </Fragment>
    )}
    {friendCount >= DEFAULT_VIEWABLE_FRIENDS && (
      <button onClick={handleClick} className="link" id="showMoreButton">
        {showMore
          ? 'Show Less'
          : 'Show More (' + (friendCount - DEFAULT_VIEWABLE_FRIENDS) + ')'}
      </button>
    )}
    <hr />
  </div>
)

export const NoRestaurantsScheduled = () => (
  <Fragment>
    <div className="row center-xs">
      <div className="noFriendsTitle">No Restaurants Scheduled</div>
    </div>
    <div className="row center-xs">
      <p className="col-xs-12 start-xs">
        Sorry, but there are currently no restaurants scheduled to deliver to
        your building today.
      </p>
    </div>
  </Fragment>
)

// Component that is visible when the user currently does not have any friends
export const NoFriendsAtLocation = ({ friendManagerPage }) => (
  <Fragment>
    <div className="row center-xs">
      <h5
        className={friendManagerPage ? 'noFriendManagerPage' : 'noFriendsTitle'}
      >
        You have no friends yet!
      </h5>
    </div>
    <div className="row center-xs noFriendsSubText">
      <p>Invite a friend/co-worker to become your friend.</p>
    </div>
    {!friendManagerPage && (
      <div className="row center-xs">
        <div className="col-xs-12 start-xs">
          <ul className="friendsPointsList">
            <li>See your friend's favorite food</li>
            <li>See where your friends ordered from</li>
          </ul>
        </div>
      </div>
    )}
  </Fragment>
)

export const AllFriendsOrdered = () => (
  <Fragment>
    <div className="row center-xs">
      <div className="noFriendsTitle">All your Friends have ordered today!</div>
    </div>
    <hr />
  </Fragment>
)

class FriendsSidebar extends Component {
  constructor(props) {
    super(props)

    this.state = { showMore: false }
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick() {
    this.setState(prevState => ({
      showMore: !prevState.showMore
    }))
  }

  componentDidMount() {
    if (this.props.selectedDate && this.props.isAuthenticated) {
      this.props.getFriendsOrdersStart(
        format(this.props.selectedDate, 'YYYY-MM-DD')
      )
    }
  }

  componentDidUpdate(prevProps) {
    // when the user changes days we want to reload their friends data and reset the state back to false so the dropdown closes
    if (
      this.props.isAuthenticated &&
      this.props.selectedDate !== prevProps.selectedDate
    ) {
      this.props.getFriendsOrdersStart(
        format(this.props.selectedDate, 'YYYY-MM-DD'),
        this.props.currentUser.deliveryLocationId
      )
      this.props.getFriendRequestCount('INCOMING')
      this.setState({ haveNotOrderedOpen: false })
    }
  }

  render() {
    const {
      requestCount,
      deliveries,
      isLoadingDeliveries,
      loadingNewDay,
      friendNotOrdered = [],
      friendHasOrdered = [],
      friendsOrderCount = [],
      isLoadingFriendsOrders,
      isLoadingFriends,
      isCurrentUserLoading,
      friendsOrdersError,
      loadFriendsError,
      isAuthenticated,
      friends = []
    } = this.props
    let {
      match: {
        params: { locationId = 0 }
      }
    } = this.props
    locationId = Number(locationId)

    return !isAuthenticated ? (
      <NotAuthed locationId={locationId} />
    ) : (
      <SpinnerCard
        spinnerActive={
          isCurrentUserLoading ||
          isLoadingDeliveries ||
          isLoadingFriendsOrders ||
          isLoadingFriends ||
          loadingNewDay
        }
      >
        <div className="friendsTitle">
          <i className="icon-users" />
          <Link to={friendsRoute.path} className="friendsLink">
            Friends
          </Link>
          {requestCount && requestCount > 0 ? (
            <span className="friendRequestBadge">{requestCount}</span>
          ) : null}
        </div>
        <hr />
        {friends &&
          friends.length === 0 &&
          !friendsOrdersError &&
          !loadFriendsError && <NoFriendsAtLocation />}
        {deliveries === null && friends && friends.length >= 1 && (
          <NoRestaurantsScheduled />
        )}
        {friendNotOrdered && friendHasOrdered && friendsOrderCount && (
          <Fragment>
            {deliveries &&
              deliveries.length > 0 &&
              friendNotOrdered &&
              friendNotOrdered.length >= 1 && (
                <FriendsNotOrderedYet
                  friendCount={friendNotOrdered.length}
                  friendNotOrdered={friendNotOrdered}
                  showMore={this.state.showMore}
                  handleClick={this.handleClick}
                  requestCount={requestCount}
                />
              )}
            {(friendsOrdersError || loadFriendsError) && (
              <InputError>{friendsOrdersError || loadFriendsError}</InputError>
            )}
            {friends.length > 0 &&
              friends.length === friendsOrderCount.length && (
                <AllFriendsOrdered />
              )}
            {friends && friends.length <= LOW_FRIENDS_CUTOFF ? (
              <AddFriends />
            ) : (
              <ManageFriends />
            )}
          </Fragment>
        )}
      </SpinnerCard>
    )
  }
}

const mapStateToProps = state => {
  const { deliveries, isLoadingDeliveries } = state.delivery
  const {
    requestCount,
    friendNotOrdered,
    friendHasOrdered,
    friendsOrderCount,
    isLoadingFriendsOrders,
    isLoadingFriends,
    friends,
    friendsOrdersError,
    loadFriendsError
  } = state.friends
  const { isCurrentUserLoading, isAuthenticated, currentUser } = state.user
  const { selectedDate, loadingNewDay } = state.home
  return {
    deliveries,
    isLoadingDeliveries,
    selectedDate,
    loadingNewDay,
    requestCount,
    friendNotOrdered,
    friendHasOrdered,
    friendsOrderCount,
    isLoadingFriendsOrders,
    isLoadingFriends,
    friends,
    isCurrentUserLoading,
    isAuthenticated,
    friendsOrdersError,
    loadFriendsError,
    currentUser
  }
}

const mapDispatchToProps = {
  getFriendRequestCount,
  getFriendsOrdersStart,
  loadFriendsStart
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FriendsSidebar)
